// AI Drawer Context - Track AI Assistant Drawer State
import { createContext, useContext, useState } from 'react';

const AIDrawerContext = createContext();

export const AIDrawerProvider = ({ children }) => {
  const [isAIDrawerOpen, setIsAIDrawerOpen] = useState(false);

  const openAIDrawer = () => setIsAIDrawerOpen(true);
  const closeAIDrawer = () => setIsAIDrawerOpen(false);
  const toggleAIDrawer = () => setIsAIDrawerOpen(prev => !prev);

  return (
    <AIDrawerContext.Provider 
      value={{ 
        isAIDrawerOpen, 
        setIsAIDrawerOpen,
        openAIDrawer,
        closeAIDrawer,
        toggleAIDrawer
      }}
    >
      {children}
    </AIDrawerContext.Provider>
  );
};

export const useAIDrawer = () => {
  const context = useContext(AIDrawerContext);
  if (!context) {
    throw new Error('useAIDrawer must be used within AIDrawerProvider');
  }
  return context;
};

export default AIDrawerContext;
